import React, { useEffect, useState, useRef, forwardRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router";
import moment from "moment";
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import Cookies from 'js-cookie';
import { initializeGA4 } from '../../utils/analytics';

import routes from "../../libs/routes";
// import consts from '../../libs/consts';

import { logIn, logOut } from "../../redux/usersSlice";
import { open, close } from "../../redux/popupSlice";
import { loadingStart, loadingEnd } from "../../redux/loadingSlice";

import Popup01 from "../popup/Popup01"

import * as API from "../../libs/service";

export default function PopupLicence(props) {
    const {
        title,
        subTitle,
        text,
        lefttext,
        width,
        button,
        buttonCancel,
        func,
        setFunc,
        noneLoading,
        top,
        cancelFunc,
        x_btn,
        cancelText,
        longButton,
        text1,
        text2,
        text3,
        text1_b,
        text2_b,
        text3_b,
        max_width,
        updateEdu
    } = props;

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { mbData } = useSelector((s) => s.usersReducer);
    const lang = useSelector(state => state.langReducer.lang);

    const [LicenseidValue, setLicenseIdValue] = useState(mbData.mb_email);
    const [LicenseidErr, setLicenseIdErr] = useState(0);
    const [LicenseidSuc, setLicenseIdSuc] = useState(false);
    const [educationStep, setEducationStep] = useState(0);
    const [time, setTime] = useState(1 * 60 * 3);
    const [timecut, setTimecut] = useState(false);
    const [code, setCode] = useState('');
    const [codeErr, setCodeErr] = useState(false);
    const [codeSuc, setCodeSuc] = useState(false);
    const [showConsent, setShowConsent] = useState(false);

    useEffect(() => {
        if (!buttonCancel && !button && top) {
            const popup = document.querySelector(".popup.show");
            /* console.log(popup); */
            if (popup) popup.classList.add("popup_top");
            const timeout = setTimeout(() => {
                dispatch(close());
            }, 1000);
            popup.addEventListener("click", () => {
                dispatch(close());
                clearTimeout(timeout);
            });
        }
    }, []);

    /* useEffect(() => {
        if(mbData?.idx) {
            setLicenseIdValue(mbData?.mb_email);
        }
    }, []); */

    useEffect(() => {
        if (!LicenseidValue) {
            setLicenseIdErr(0)
        }
    }, [LicenseidValue]);

    useEffect(() => {
        if (educationStep === 1 && time > 0) {
            const timer = setInterval(() => {
                setTime(prevTime => {
                    if (prevTime === 1) {
                        setTimecut(true);
                    }
                    return prevTime - 1;
                });
            }, 1000);

            return () => clearInterval(timer);
        } else if (time === 0) {
            setTimecut(true);
        }
    }, [educationStep, time]);

    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
    };

    const setFunction = () => {
        if (setFunc) setFunc();
        dispatch(close());
    };

    const emailCheck = (value) => {
        let EmailChk = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        setLicenseIdValue(value)

        if (!EmailChk.test(value)) {
            setLicenseIdErr(1);
            setLicenseIdSuc(false);
            return;
        } else {
            setLicenseIdErr(0);
        }

        if (value && EmailChk.test(value)) {
            setLicenseIdSuc(true)
        } else {
            setLicenseIdSuc(false)
        }
    };

    useEffect(() => {
        if (mbData?.mb_email) {
            emailCheck(mbData.mb_email);
        }
    }, [mbData]);

    const InputChange = (event) => {
        const { name, value } = event.target;

        if (name === "education_pop_input") {
            emailCheck(value);
        }

        if (name === "code") {
            const onlyNumbers = /^[0-9]*$/;
            setCode(value);

            if (onlyNumbers.test(value)) {
                if (value.length === 4) {
                    setCodeSuc(true);
                } else {
                    setCodeSuc(false);
                }
            }
        }
    }

    const LicenseSucChk = async () => {
        if (educationStep === 0) {
            dispatch(loadingStart());

            console.log("mbData.emaillanguage : ", mbData?.emailLanguage);
            if (LicenseidSuc) {
                const res = await API.get(`etc/partner/${LicenseidValue}/${mbData?.emailLanguage || 'en'}`);
                console.log("res : ", res);
                if (res?.data?.msg === 'success') {
                    setEducationStep(1);
                } else if (res?.data?.msg === 'err1'){
                    setLicenseIdErr(1);
                    setEducationStep(3);
                } else if (res?.data?.msg === 'err2'){
                    setEducationStep(4);
                }
                dispatch(loadingEnd());
            } else {
                setLicenseIdErr(1);
                setTimeout(() => {
                    setEducationStep(3); // 파트너 학교 메일이 아닐시 테스트
                    dispatch(loadingEnd());
                }, 1000)
            }
        }

        if (educationStep === 1) {
            dispatch(loadingStart());

            if (codeSuc) {
                const res = await API.get(`etc/partnercode/${LicenseidValue}/${code}`);
                console.log("Res : ", res);
                if (res?.data?.msg === 'success') {
                    setEducationStep(2);
                } else if (res?.data?.msg === 'err1') {
                } else if (res?.data?.msg === 'err2') {
                    setCodeErr(1);
                }

                dispatch(loadingEnd());
                // setTimeout(() => {
                //     setEducationStep(2);
                //     dispatch(loadingEnd());
                // }, 1000)
            } else {
                setTimeout(() => {
                    dispatch(open({
                        component:
                            <Popup01
                                x_btn={true}
                                text1={lang === 0 ? '오류가 발생했습니다.' : 'An error has occurred.'}
                                longButton={lang === 0 ? '확인' : 'OK'}
                            />
                    }));
                    dispatch(loadingEnd());
                }, 1000)
            }
        }
    }

    useEffect(() => {
        const hasConsent = Cookies.get('ga_consent');
        console.log('ga_consent:', hasConsent); // 시크릿 모드에서 undefined가 찍혀야 정상
        if (!hasConsent) {
            setShowConsent(true);
        } else if (hasConsent === 'true') {
            initializeGA4('accepted');
        }
    }, []);

    return (
        <>
            <div
                className={"popup_default01"}
                style={{
                    maxWidth: max_width ? max_width : '400px',
                    width: '100%',
                    marginLeft: 10,
                    marginRight: 10,
                }}
            >
                {x_btn &&
                    <div
                        className="popup_x_btn_box edu_license"
                    >
                        {/* <p className="title">{lang === 0 ? 'UModeler X School 신청' : 'Apply for UModeler X School'}</p> */}
                        <p className="title">{lang === 0 ? 'School 라이선스 신청' : 'Apply for School Lisence'}</p>
                        <img src={require("../../assets/images/exit-icon.svg").default}
                            className="popup_x_btn"
                            onClick={() => {
                                dispatch(close());
                            }}
                            style={{ cursor: isBrowser ? 'pointer' : 'auto' }}
                        />
                    </div>
                }
                <div
                    className={`popup_content_box edu_license ${educationStep === 0 ? 'step0' : educationStep === 1 ? 'step1' : educationStep === 2 ? 'step2' : 'step3'}`}
                >
                    {text1 &&
                        <div
                            className="popup_text_box"
                        >
                            <p>{text1}</p>
                        </div>
                    }

                    {text1_b && // 마진 위아래 있음
                        <div
                            className="popup_text_box mar"
                        >
                            <b>{text1_b}</b>
                        </div>
                    }

                    {text2 &&
                        <div
                            className="popup_text_box"
                        >
                            <p>{text2}</p>
                        </div>
                    }

                    {text2_b &&
                        <div
                            className="popup_text_box"
                        >
                            <b>{text2_b}</b>
                        </div>
                    }

                    {text3 &&
                        <div
                            className="popup_text_box"
                        >
                            <p>{text3}</p>
                        </div>
                    }

                    {text3_b &&
                        <div
                            className="popup_text_box"
                        >
                            <b>{text3_b}</b>
                        </div>
                    }

                    {title &&
                        <div
                            className="popup_title_box"
                        >
                            <p>{title}</p>
                        </div>
                    }

                    {subTitle &&
                        <div
                            className="popup_sub_title_box"
                        >
                            <p>{subTitle}</p>
                        </div>
                    }
                    {text &&
                        <div
                            className="popup_text_box"
                            style={!buttonCancel && !button ? { padding: "0" } : {}}
                        >
                            <p>{text}</p>
                        </div>
                    }

                    {lefttext &&
                        <div
                            className="popup_left_text_box"
                            style={!buttonCancel && !button ? { padding: "0" } : {}}
                        >
                            <p>{lefttext}</p>
                        </div>
                    }

                    {educationStep == 4 &&
                        <div className="education_pop_box">
                            <div className="text_box step1">
                                <p>{LicenseidValue}</p>
                                <p className="sub">
                                    {lang === 0 ? '파트너 이메일이지만, 아직 가입되지 않았습니다.' : 'This is a partner email, but it has not been registered yet.'}<br />
                                    {lang === 0 ? '회원가입 후 진행해주세요.' : 'Please sign up before proceeding.'}<br />
                                </p>
                            </div>


                            <button
                                type="button"
                                className="custom_btn"
                                onClick={() => {
                                    dispatch(close());
                                    navigate('/Register');
                                }}
                            >
                                {lang === 0 ? '회원가입' : 'Register'}
                            </button>
                        </div>
                    }

                    {educationStep == 0 &&
                        <div className="education_pop_box">
                            <div className="text_box">
                                <img src={require("../../assets/icon/chk_emoji.svg").default} />

                                {lang === 0 && <strong>학교 관계자</strong> }
                                {lang === 0 && '라면,' }
                                <span
                                    onClick={() => {
                                        window.open('https://bit.ly/4i8y08p', '_blank');
                                        dispatch(close());
                                        // GA4 이벤트 추가
                                        window.gtag('event', 'click_school_apply_hangul_1', {
                                             event_category: 'link',
                                             event_label: '학교 신청하기',
                                             value: 1
                                         });
                                    }}
                                >
                                {lang === 0 && '여기'}
                                </span>
                                {lang === 0 && '에서 '}
                                {lang === 0 && <strong>파트너 학교</strong>}
                                {lang === 0 && '를 신청하세요. School 라이선스를 통해 UModeler X를 활용한 강의를 적극 지원해드립니다.'}

                                {lang !== 0 && 'If you\'re a ' }
                                {lang !== 0 && <strong>School</strong>}
                                {lang !== 0 && ', click'}
                                <span
                                    onClick={() => {
                                        window.open('https://bit.ly/3Elky3h', '_blank');
                                        dispatch(close());
                                        // GA4 이벤트 추가
                                        window.gtag('event', 'click_school_apply_eng_1', {
                                             event_category: 'link',
                                             event_label: 'Apply Partner School',
                                             value: 1
                                        });
                                    }}
                                >
                                    {lang !== 0 && 'here'}
                                </span>
                                {lang !== 0 && ' to apply as a '}
                                {lang !== 0 && <strong>Partner School</strong>}
                                {lang !== 0 && '. We\'ll actively support your courses with the UModeler X School License.'}

                            </div>

                            <div className="text_box">
                                <img src={require("../../assets/icon/chk_emoji.svg").default} />
                                
                                {lang === 0 && <strong>교육자</strong>}
                                {lang === 0 && '이거나 '}
                                {lang === 0 && <strong>학생</strong>}
                                {lang === 0 && '이라면'}
                                <span
                                        onClick={() => {
                                            window.open('https://bit.ly/3EjQtB1', '_blank');
                                            dispatch(close());
                                            // GA4 이벤트 추가
                                            window.gtag('event', 'click_school_apply_popup_hangul_2`', {
                                                 event_category: 'link',
                                                 event_label: '학교 신청하기',
                                                 value: 1
                                             });
                                        }}
                                >
                                {lang === 0 && '여기'}
                                </span>
                                {lang === 0 && '에서 신청하세요. 재직증명서 혹은 재학증명서를 통해 인증하여 UModeler X를 자유롭게 가르치고 학습해보세요.' }

                                {lang !== 0 && 'If you\'re an '}
                                {lang !== 0 && <strong>Educator</strong>}
                                {lang !== 0 && ' or '}
                                {lang !== 0 && <strong>Student</strong>}
                                {lang !== 0 && ', click'}
                                <span
                                    onClick={() => {
                                        window.open('https://bit.ly/4lxaIw0', '_blank');
                                        dispatch(close());
                                        // GA4 이벤트 추가
                                        // window.gtag('event', 'click_school_apply_eng_2', {
                                        //     event_category: 'link',
                                        //     event_label: 'Apply Partner School',
                                        //     value: 1
                                        // });
                                    }}
                                >
                                {lang !== 0 && 'here'}
                                </span>
                                {lang !== 0 && ' to apply. With a valid certificate of employment or enrollment, you can freely teach and learn using UModeler X.' }

                            </div>

                            <div className="text_box">
                                <img src={require("../../assets/icon/chk_emoji.svg").default} />
                                {lang === 0 && <strong>파트너 학교</strong>}
                                {lang === 0 && '의 멤버라면 아래에 학교 도메인의 이메일을 입력하여 빠르게 '}
                                {lang === 0 && <strong>School 라이선스</strong>}
                                {lang === 0 && '를 신청하세요.'}

                                {lang !== 0 && <strong>Partner School</strong>}
                                {lang !== 0 && ' members can quickly apply for a '}
                                {lang !== 0 && <strong>School License</strong>}
                                {lang !== 0 && ' with their school domain email below.'}
                            </div>

                            <p className="email">{lang === 0 ? '이메일' : 'Email'}</p>

                            <input
                                type="text"
                                className="education_pop_input"
                                placeholder={lang === 0 ? "학교 도메인 이메일을 입력하세요." : "Enter your school domain email."}
                                name="education_pop_input"
                                value={LicenseidValue}
                                onChange={InputChange}
                            />
                            {LicenseidErr == 1 &&
                                <span className="err_msg id" style={{ margin: 0 }}>
                                    {lang === 0 ? '이메일 형식이 올바르지 않습니다.' : 'The email format is incorrect.'}
                                </span>
                            }
                        </div>
                    }

                    {educationStep == 1 &&
                        <div className="education_pop_box">
                            <div className="text_box step1">
                                <p>{LicenseidValue}</p>
                                <p className="sub">
                                    {lang === 0 ? '이메일로 인증번호를 전송했습니다.' : 'A verification code has been sent to your email.'}
                                </p>
                            </div>

                            <div className="login_input_box">
                                <div
                                    className="input_div"
                                    style={{
                                        marginTop: '20px',
                                    }}
                                >
                                    <input
                                        type="text"
                                        placeholder={lang === 0 ? "인증번호 입력" : 'Enter Code'}
                                        className="input_id"
                                        name="code"
                                        value={code}
                                        onChange={InputChange}
                                        maxLength={4}
                                    />
                                    <span
                                        style={{
                                            color: '#0E6AF4',
                                            fontSize: '12px',
                                            position: 'absolute',
                                            right: '12px',
                                            top: 'calc(50% - 10px)'
                                        }}
                                    >
                                        {formatTime(time)}
                                    </span>
                                </div>
                            </div>

                            {codeErr === 1 && 
                                <span className="err_msg id" style={{ marginTop: '-12px', textAlign: 'center' }}>
                                    {lang === 0 ? '인증번호가 일치하지 않습니다.' : 'The verification code does not match.'}
                                </span>
                            }
                            {codeErr === 2 && 
                                <span className="err_msg id" style={{ marginTop: '-12px', textAlign: 'center' }}>
                                    {lang === 0 ? '인증번호가 만료되었습니다 다시 시도해 주세요.' : 'The verification code has expired. Please try again.'}
                                </span>
                            }

                            <button
                                type="button"
                                className={`custom_btn ${!codeSuc ? 'off' : ''}`}
                                onClick={() => {
                                    if (timecut) {
                                        setCodeErr(2);
                                    } else if (!code) {
                                        setCodeErr(1);
                                    } else if (codeSuc) {
                                        LicenseSucChk()
                                    }
                                }}
                            >
                                {lang === 0 ? '확인' : 'OK'}
                            </button>
                        </div>
                    }

                    {educationStep == 2 &&
                        <div className="education_pop_box">
                            <div className="text_box step2">
                                <p>{lang === 0 ? '확인 되었습니다.' : 'Verification Successful.'}</p>

                                <button
                                    type="button"
                                    className="custom_btn"
                                    onClick={() => {
                                        dispatch(close());
                                        navigate(routes.Licensing);
                                    }}
                                >
                                    {lang === 0 ? '라이선스 확인하기' : 'Check License'}
                                </button>

                                <span>
                                    {lang === 0
                                        ? '[프로필] → [라이선스 관리]에서 학교 라이선스를 확인하세요'
                                        : 'Check your school license in [Profile] → [License Management]'}
                                </span>
                            </div>
                        </div>
                    }

                    {educationStep == 3 &&
                        <div className="education_pop_box">
                            <div className="text_box step1">
                                <p>{LicenseidValue}</p>
                                <p className="sub" style={{ color: 'red'}}>
                                    {lang === 0
                                        ? '파트너 기관의 이메일이 아닙니다.'
                                        : 'This is not a partner institution email.'}<br />
                                    {/* {lang === 0
                                        ? '[문의 하기]를 통해 학생 혹은 교육기관 관계자 임을 증빙해주세요.'
                                        : 'Please verify your status as a school or educational institution representative via [Inquiry].'} */}
                                </p>
                            </div>
                            <div className="text_box">
                                <img src={require("../../assets/icon/chk_emoji.svg").default} />

                                {lang === 0 && <strong>학교 교육 기관 관계자</strong> }
                                {lang === 0 && '라면,' }
                                <span
                                    onClick={() => {
                                        window.open('https://bit.ly/4i8y08p', '_blank');
                                        dispatch(close());
                                    }}
                                >
                                {lang === 0 && '여기'}
                                </span>
                                {lang === 0 && '에서 파트너 기관을 신청하세요. School 라이선스를 통해 UModeler X를 활용한 강의를 적극 지원해드립니다.'}

                                {lang !== 0 && 'If you\'re an ' }
                                {lang !== 0 && <strong>Educational Institution</strong>}
                                {lang !== 0 && ', click'}
                                <span
                                    onClick={() => {
                                        window.open('https://bit.ly/3Elky3h', '_blank');
                                        dispatch(close());
                                    }}
                                >
                                    {lang !== 0 && 'here'}
                                </span>
                                {lang !== 0 && ' to apply as a Partner School. We\'ll actively support your courses with the UModeler X School License.'}

                            </div>

                            <div className="text_box">
                                <img src={require("../../assets/icon/chk_emoji.svg").default} />
                                
                                {lang === 0 && <strong>교육자</strong>}
                                {lang === 0 && '이거나 '}
                                {lang === 0 && <strong>학생</strong>}
                                {lang === 0 && '이라면'}
                                <span
                                    onClick={() => {
                                        window.open('https://bit.ly/3EjQtB1', '_blank');
                                        dispatch(close());
                                    }}
                                >
                                {lang === 0 && '여기'}
                                </span>
                                {lang === 0 && '에서 신청하세요. 재직증명서 혹은 재학증명서를 통해 인증하여 UModeler X를 자유롭게 가르치고 학습해보세요.' }

                                {lang !== 0 && 'If you\'re an '}
                                {lang !== 0 && <strong>Educator</strong>}
                                {lang !== 0 && ' or '}
                                {lang !== 0 && <strong>Student</strong>}
                                {lang !== 0 && ', click'}
                                <span
                                    onClick={() => {
                                        window.open('https://bit.ly/4lxaIw0', '_blank');
                                        dispatch(close());
                                    }}
                                >
                                {lang !== 0 && 'here'}
                                </span>
                                {lang !== 0 && ' to apply. With a valid certificate of employment or enrollment, you can freely teach and learn using UModeler X.' }

                            </div>
                            <button
                                type="button"
                                className="custom_btn"
                                onClick={() => {
                                    dispatch(close());
                                    //navigate(routes.Inquiry);
                                }}
                            >
                                {lang === 0 ? '닫기' : 'Close'}
                            </button>
                        </div>
                    }


                    {educationStep === 0 &&
                        <>
                            {(buttonCancel || button || longButton) &&
                                <div className="popup_btn_box edu_license">
                                    {buttonCancel && (
                                        <button
                                            className="button_cancel"
                                            onClick={() => {
                                                if (func === "setRightFunc") {
                                                    setFunction();
                                                } else {
                                                    if (cancelFunc) cancelFunc();
                                                    dispatch(close());
                                                }
                                            }}
                                        >
                                            {buttonCancel}
                                        </button>
                                    )}
                                    {button && (
                                        <button
                                            className={`button_success ${!LicenseidSuc ? 'license_edu_off' : ''}`}
                                            onClick={() => {
                                                LicenseSucChk();
                                            }}
                                        >
                                            {button}
                                        </button>
                                    )}
                                    {longButton && (
                                        <button
                                            className="button_success long"
                                            onClick={() => {
                                                if (func === "setRightFunc") {
                                                    dispatch(close());
                                                } else {
                                                    setFunction();
                                                }
                                            }}
                                        >
                                            {longButton}
                                        </button>
                                    )}
                                </div>
                            }
                        </>
                    }
                </div>
            </div>
        </>
    );
}